<template>
    <div class="toggle-block">
        <div class="label">
            {{ label }}
        </div>

        <div class="toggle-button" :class="classBindings" @click="toggle">
            <!-- <div class="toggle-indicator"></div> -->
            <div 
                class="value" 
                v-for="(label, index) in toggleLabels"
                :key="index"
            >  
                {{ label }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: Boolean,
        label: String,
        toggleLabels: Array
    },
    methods: {
        toggle() {
            this.$emit('toggle');
        }
    },
    computed: {
        classBindings() {
            return {
                toggle: true,
                active: this.value
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../scss/abstracts/variables";


.toggle-block {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;

    .toggle {
        margin: 0 1.5rem;
        // width:68px;
        // padding:5px;
        background: transparent;
        border-radius: 50px;
        transition: background-color 500ms ease-out;
        border: solid 1px $color-primary;

        // &.active {
        //     background-color: $color-primary;
        //     .toggle-indicator {
        //         transform: translateX(36px);
        //     }
        // }

        // &-indicator {
        //     width:22px;
        //     height:22px;
        //     background-color: $brand-white;
        //     border-radius:33px;
        //     transition: transform 100ms ease-out;
        // }

        .value {
            padding: 8px 20px;
            transition: color 300ms;
            border-radius: 50px;
            font-size: 14px;

            &:first-child {
                margin-right: -10px;
                background-color: $color-primary;
                color: #ffffff;
            }
            
            &:last-child {
                background-color: transparent;
                color: inherit;
            }
        }

        &.active {
            .value {
                &:first-child {
                    background-color: transparent;
                    color: inherit;
                }

                &:last-child {
                    background-color: $color-primary;
                    color: #ffffff;
                }
            }
        }
    }

    .label {
        font-family: $font-primary-med;
        font-size: 16px;

        @media (max-width:767px) {
            white-space: nowrap;
        }
    }
}

.toggle-button {
    display: flex;
}
</style>
